<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="top-center"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Lot_Item_Relocation_Title' | translateWF: 'Relocate Lot Items' }}</h1>

        <div class="page__title_buttons">
          <div class="relocation__tabs">
            <button type="button" class="relocation__tab" (click)="redirectToDetails()">
              {{ 'Lot_Item_Relocation_Tab_Relocate' | translateWF: 'Relocate' }}
            </button>
            <button type="button" class="relocation__tab relocation__tab--active">
              {{ 'Lot_Item_Relocation_Tab_History' | translateWF: 'Movement history' }}
              <span>· {{ totalRecords() }}</span>
            </button>
          </div>
        </div>
      </div>

      <p class="page__subtitle">
        {{ 'Lot_Item_Relocation_Subtitle' | translateWF: 'Choose a warehouse, then scan rolls, chemicals or pallets and a destination in any order.' }}
      </p>
    </div>

    <section class="relocation__history">
      <p-table [value]="relocations()" selectionMode="single" styleClass="relocation__history_table">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'Lot_Item_Relocation_Movement_Id' | translateWF: 'Movement ID' }}</th>
            <th>{{ 'Common_Date' | translateWF: 'Date' }}</th>
            <th>{{ 'Lot_Item_Relocation_Lot_Items' | translateWF: 'Lot Items' }}</th>
            <th>{{ 'Lot_Item_Relocation_From_Short' | translateWF: 'From' }}</th>
            <th>{{ 'Lot_Item_Relocation_To' | translateWF: 'To' }}</th>
            <th>{{ 'Lot_Item_Relocation_Moved_By' | translateWF: 'Moved by' }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          @let relocation = getRelocation(row);
          <tr class="cursor-pointer" (click)="redirectToDetails(relocation.id)">
            <td class="relocation__history_number">{{ relocation.number }}</td>
            <td>{{ relocation.createdDate | hnDate: 'yyyy/MM/dd HH:mm' }}</td>
            <td>
              <span class="relocation__history_count">
                {{ relocation.lines.length }}
                @if (relocation.lines.length === 1) {
                  {{ 'Lot_Item_Relocation_Lot_Item_Singular' | translateWF: 'Lot Item' }}
                } @else {
                  {{ 'Lot_Item_Relocation_Lot_Items' | translateWF: 'Lot Items' }}
                }
              </span>
              <span class="relocation__history_numbers">{{ getLotItemNumbers(relocation) }}</span>
            </td>
            <td class="relocation__history_from">{{ getFromLocations(relocation) }}</td>
            <td>
              @if (relocation.toLocationCode) {
                <span class="relocation__history_destination">
                  <i class="pi pi-map-marker"></i>
                  {{ relocation.toLocationCode }}
                </span>
              }
            </td>
            <td>{{ getMovedBy(relocation) }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center">
              {{ 'Lot_Item_Relocation_History_Empty' | translateWF: 'No relocations found' }}
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="relocation__history_footer">
        @if (totalRecords() > pageSize()) {
          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            [rowsPerPageOptions]="[25, 50, 100]"
            (onPageChange)="onPageChange($event)"
          />
        }

        <span class="relocation__history_summary">
          {{ 'Lot_Item_Relocation_Showing' | translateWF: 'Showing' }}
          {{ firstRecord() }} {{ 'Lot_Item_Relocation_To_Range' | translateWF: 'to' }} {{ lastRecord() }} {{ 'Lot_Item_Relocation_Of' | translateWF: 'of' }} {{ totalRecords() }}
          {{ 'Lot_Item_Relocation_Entries' | translateWF: 'entries' }}
        </span>
      </div>
    </section>
  </div>
</main>
